import { render } from "./CheckboxPreview.vue?vue&type=template&id=6816b7b0&scoped=true"
import script from "./CheckboxPreview.vue?vue&type=script&lang=js"
export * from "./CheckboxPreview.vue?vue&type=script&lang=js"

import "./CheckboxPreview.vue?vue&type=style&index=0&id=6816b7b0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6816b7b0"]])

export default __exports__